import { EmailQuery } from '@src/types';
import axios, { AxiosResponse } from 'axios';

export const getUsers = (params?: EmailQuery): Promise<AxiosResponse<any>> => {
  return axios.get(`internal-users`, { params: { ...params, size: 20 } });
};

export const createUser = (data: any): Promise<AxiosResponse<any>> => {
  return axios.post(`internal-users`, data);
};

// Example payload of updateUser: {
//   "email": "string",
//   "username": "string",
//   "fullname": "string",
//   "password": "string",
//   "account_active": true,
//   "internal_notes": "string"
// }
export const updateUser = (
  userId: string,
  data: any
): Promise<AxiosResponse<any>> => {
  return axios.put(`internal-users/${userId}/`, data);
};

// Example response of getUserDetail: {
//   "id": 0,
//   "email": "string",
//   "role": "string",
//   "permissions": [
//     "string"
//   ],
//   "password": "string",
//   "username": "string",
//   "first_name": "string",
//   "last_name": "string",
//   "phone_number": "string",
//   "fullname": "string",
//   "internal_notes": "string",
//   "monthly_reset_allowed": 0,
//   "monthly_new_accounts_allowed": 0,
//   "account_active": true,
//   "created_at": "2026-03-24T15:05:02.108Z",
//   "updated_at": "2026-03-24T15:05:02.108Z",
//   "deleted_at": "2026-03-24T15:05:02.108Z"
// }
export const getUserDetail = (userId: string): Promise<AxiosResponse<any>> => {
  return axios.get(`internal-users/${userId}/`);
};

// Example payload of updateUserRole: {
//   "role": "string",
//   "permissions": [
//     "string"
//   ],
//   "monthly_reset_allowed": 0,
//   "monthly_new_accounts_allowed": 0
// }
export const updateUserRole = (
  userId: string,
  payload: any
): Promise<AxiosResponse<any>> => {
  return axios.put(`internal-users/${userId}/roles/`, payload);
};
